import { Sort } from '../models/sort.model';

export const EntriesDefaultSortValue: Sort = {
  sortBy: 'updateInfo.doneAt',
  sortDir: 'desc',
};
export const OrderableEntityDefaultSortValue: Sort = {
  sortBy: '_metaOrder.value',
  sortDir: 'asc',
};
